import {
    RATEQUOTE_LIST,
    RATEQUOTE_PAGINATION,
    RATEQUOTE_SUMMARY,
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';
import { callLoader } from '../Loader/actions';
import { ca } from 'date-fns/locale';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getRateQuoteList = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const queryParams = new URLSearchParams({
                ...payload,
            }).toString();
            const url = `v1/RateQuote/GetRateQuoteList?${queryParams}`;
            return APICall('get', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === '201') {
                    dispatch({
                        type: RATEQUOTE_LIST,
                        payload: result?.data || [],
                    });
                    dispatch({
                        type: RATEQUOTE_PAGINATION,
                        payload: result?.pagination || {},
                    });
                    dispatch({
                        type: RATEQUOTE_SUMMARY,
                        payload: result?.summary || {},
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);

        } finally {
            dispatch(callLoader(false));
        }

    };
};


export const getCancelledRateQuoteList = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const queryParams = new URLSearchParams({
                ...payload,
            }).toString();
            const url = `v1/RateQuote/GetCancelledRateQuoteList?${queryParams}`;
            return APICall('get', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === '201') {
                    dispatch({
                        type: RATEQUOTE_LIST,
                        payload: result?.data || [],
                    });
                    dispatch({
                        type: RATEQUOTE_PAGINATION,
                        payload: result?.pagination || {},
                    });
                    dispatch({
                        type: RATEQUOTE_SUMMARY,
                        payload: result?.summary || {},
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);

        } finally {
            dispatch(callLoader(false));
        }
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getRateQuoteByID = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const url = `v2/RateQuote/GetRateQuoteByID?RateQuoteId=${payload}`;
            return APICall('get', payload, url).then(result => {
                if (result?.statuscode === 200) {
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        } finally {
            dispatch(callLoader(false));
        }
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createRateQuote = (payload) => {
    try {
        const url = `v2/RateQuote/CreateRateQuote`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
                await getRateQuoteList(payList);
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateRateQuote = async (payload) => {
    try {
        const url = `v2/RateQuote/UpdateRateQuote`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200) {
                const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
                await getBookingList(payList);
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const deleteRateQuote = (payload) => {
    const url = `v1/RateQuote/DeleteRateQuoteList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const reinstateRateQuoteList = (payload) => {
    const url = `v1/RateQuote/ReinstateRateQuoteList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getRateQuoteNotes = async (payload) => {
    try {
        const url = `v1/RateQuote/GetRateQuoteNotes?RateQuoteId=${payload}`;
        return APICall('get', payload, url).then(async result => {
            if (result?.statuscode === 200) {
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const insertRateQuoteNotes = async (payload) => {
    try {
        const url = `v1/RateQuote/InsertRateQuoteNotes`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return getRateQuoteNotes(payload?.RateQuoteId);
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getAddressBookNotes = async (payload) => {
    try {
        const url = `v1/Common/GetAddressBookNotes?addressid=${payload}&type=E`;
        return APICall('get', {}, url).then(async result => {
            if (result?.statuscode === 200) {
                return result?.data || [];
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createBookingRateQuote = async (payload) => {
    try {
        const url = `v1/RateQuote/CreateBooking`;
        return APICall('post', payload, url).then(async result => {
            return result;
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

